// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import BaseStatePlusSprite from "../../../../../engines/components/state/BaseStatePlusSprite";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import UserDataManage from "../../../model/UserDataManage";

const {ccclass, property} = cc._decorator;

enum CityState {
    NOT_GET = 0,
    OWN,
    DROP,
}
@ccclass
export default class MilitaryCityItem extends BaseComponent {

	@property({ type: cc.Sprite, displayName:'' })
	sprBg: cc.Sprite = null;

	@property({ type: BaseStatePlusSprite, displayName:'' })
	sprState: BaseStatePlusSprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

    
    private cityId: string = null;
    private csvInfo: any = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.CITY, this.cityId);
        this.initUI();

        O1HD.on(MessageEventKind.EventName.REFRESH_CITY_DROP_STATE, this.refreshCityDropState, this);
    }

    setData(
        cityId: string
    ) {
        this.cityId = cityId;
    }

    refreshState() {
        let militaryCityDataManage = UserDataManage.instance.militaryCityDataManage;
        let militaryCityData = militaryCityDataManage.militaryCityData;
        let cityData = militaryCityData.lists.get(this.cityId);

        // 
        let stateIdx = CityState.NOT_GET;
        if (cityData) {
            if (cityData.bDrop) {
                stateIdx = CityState.DROP;
            } else {
                stateIdx = CityState.OWN;
            }
        } 
        this.sprState.setFill(stateIdx);
    }

    refreshCityDropState(cityId: string) {
        if (this.cityId != cityId) {
            return;
        }
        this.refreshState();
    }

    initUI() {
        this.labelName.string = this.csvInfo.name;

        this.refreshState();

        this.sprBg.node.active = false;
        if (utilsModel.isValidNumberValue(this.csvInfo.icon)) {
            let iconPath = "res/map/small/cityItem/" + this.csvInfo.icon;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.militaryBundle).load(iconPath, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        this.sprBg.node.active = true;
                        this.sprBg.spriteFrame = imgs;
                    }
                }
            );
        }
    }

    onClickOpen() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MilitaryCityInfoLayer
            , null
            , {
                cityId: this.cityId
                , parent: this
            }
        );
    }

    // update (dt) {}
}
